import React from 'react'
import styles from './Request.module.scss'
import { Wrapper } from 'components/Wrapper/Wrapper'
import { WelcomeBlock } from '../../components/WelcomeBlock/WelcomeBlock'
import { Profile } from './components/Profile/Profile'
import { Balance } from './components/Balance/Balance'
import { MoneyTarget } from './components/MoneyTarget/MoneyTarget'
import { Dashboard } from 'components/Dashboard/Dashboard'
import { PopupEditPage } from 'components/PopupEditPage/PopupEditPage'
import { REQUEST_ANALYTICS, REQUEST_MOCK_DATA } from './consts'
import { useIsMobile } from 'hooks/useIsMobile'


export function Request() {
    const [showPopup, setShowPopup] = React.useState(false)
    const { isMobile } = useIsMobile()

    function openPopupEditPage() {
        setShowPopup(true)
    }

    function closePopupEditPage() {
        setShowPopup(false)
    }

    // test data if deposite and balance = 0
    const isDepositZero = false

    // test data if it no Public
    const isPublic = true

    // test data moneyTarger
    const moneyTarget = 1000

    if (isMobile) {
        return (
            <>
                <div className={styles['mobile']}>
                    <div className={styles['mobile__content']}>
                        <div className={styles['welcome']}>
                            <WelcomeBlock
                                text='Your balance is $0 at the moment. Wait before it starts growing. ' />
                        </div>
                        <Balance amount={130.2} isBalanceZero={isDepositZero} />
                        <Profile
                            isPublic={isPublic}
                            onCustomize={openPopupEditPage}
                        />
                        <MoneyTarget amount={moneyTarget} />
                        <Dashboard data={REQUEST_MOCK_DATA} analytics={REQUEST_ANALYTICS} />
                    </div>
                </div>
                {showPopup && <PopupEditPage onClose={closePopupEditPage} />}
            </>
        )
    }

    return (
        <>
            <Wrapper>
                <div className={styles['container']}>
                    <div className={styles['info']}>
                        <div className={styles['welcome']}>
                            <WelcomeBlock
                                text='Your balance is $0 at the moment. Wait before it starts growing. ' />
                        </div>
                        <div className={styles['content']}>
                            <Profile
                                isPublic={isPublic}
                                onCustomize={openPopupEditPage}
                            />
                            <div className={styles['balance']}>
                                <Balance amount={130.2} isBalanceZero={isDepositZero} />
                                {!isDepositZero && <MoneyTarget amount={moneyTarget} />}
                            </div>
                        </div>
                    </div>
                    <Dashboard data={REQUEST_MOCK_DATA} analytics={REQUEST_ANALYTICS} />
                </div>
            </Wrapper>
            {showPopup && <PopupEditPage onClose={closePopupEditPage} />}
        </>
    )
}

